import { SetAuthToken } from '../../ngrx/action/auth.action';
import { ApplicationState } from '../../../reducers';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import jwt_decode from 'jwt-decode';
import moment from 'moment';
import _get from 'lodash-es/get';
import { UpdateUserState } from '../../ngrx/action/user.action';
import { DatadogContextData, DatadogService, DatadogUserData } from '@dn/libs/ui/dn-common';

@Injectable({
  providedIn: 'root',
})
export class TokenValidatorService {
  constructor(
    private readonly store: Store<ApplicationState>,
    private readonly datadogService: DatadogService,
  ) {}

  isTokenValid(token): boolean {
    try {
      jwt_decode(token, { header: true });
      return true;
    } catch (error) {
      return false;
    }
  }

  isTokenExpired(token): boolean {
    try {
      const decodedToken = jwt_decode(token);
      const timeNow = moment.unix(Date.now() / 1000).format();
      const timeExp = moment.unix(_get(decodedToken, 'exp')).format();
      return !moment(timeNow).isSameOrBefore(timeExp);
    } catch (error) {
      return true;
    }
  }

  setTokenToStore(token) {
    this.store.dispatch(SetAuthToken({ authToken: token }));
  }

  setUserToStore(token) {
    const userDetails = this.getTokenDecodedValues(token);
    const userId = _get(userDetails, 'userId', '');
    const email = _get(userDetails, 'email', '');
    const teamId = _get(userDetails, 'teamId', '');
    const payload = {
      userId,
      email,
    };
    const datadogUserData: DatadogUserData = {
      id: userId,
      email,
    };
    const datadogContextData: DatadogContextData = {
      teamId,
    };
    this.datadogService.setUserId(datadogUserData);
    this.datadogService.setGlobalContext(datadogContextData);
    this.store.dispatch(UpdateUserState({ payload }));
  }

  getTokenDecodedValues(token) {
    try {
      const decodedToken = jwt_decode(token);
      return decodedToken;
    } catch (error) {
      return {
        error: true,
        errorType: 'CANT_DECODE_TOKEN',
      };
    }
  }
}
